import { jsx as m } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { chakra as c, useStyleConfig as g } from "@chakra-ui/react";
const p = {
  XL: "xl",
  LG: "lg",
  MD: "md",
  SM: "sm"
}, H = a(
  ({ __css: s, as: e = "h2", size: o = "lg", ...r }, t) => {
    const n = c[e], i = g("HeadingTheme", {
      size: o
    });
    return /* @__PURE__ */ m(n, { ref: t, __css: { ...i, ...s }, ...r });
  }
);
export {
  H as Heading,
  p as HeadingSizes
};
//# sourceMappingURL=Heading.es.js.map
